import {  PermissionProp, stateStatusType } from './actionType';

export interface FetchPermissions {
    isLoading: boolean;
    error: string | null;
    permission: PermissionProp[] | null;
    status: stateStatusType | null;
}
export interface GenericFetchPermissions {
    isLoading: boolean;
    error: string | null;
    status: stateStatusType | null;
}

export const initalFetchPermissions: FetchPermissions = {
    isLoading: false,
    error: null,
    permission: null,
    status: null,
};
export const initalGenericFetchPermissions: GenericFetchPermissions = {
    isLoading: false,
    error: null,
    status: null,
};

export interface PermissionState {
    fetchPermissionState: FetchPermissions;
    genericPermissionState: GenericFetchPermissions
}

export const initialState: PermissionState = {
    fetchPermissionState: initalFetchPermissions,
    genericPermissionState: initalGenericFetchPermissions
};